import { Component, OnInit } from '@angular/core';
import { FlagService, ToastService, ValidationService, DataService, AgeGroupService } from '@core/services';
import { HIPInsuredPersonFromHIPDto } from 'src/app/modules/_services/api/@generated/models';
import { HomeComponent } from '../../home.component';
import { APIClient } from 'src/app/modules/_services/api/@generated';
import { HIPContractDto } from 'src/app/modules/_services/api/@generated/models';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dropdown-frame',
  templateUrl: './dropdown-frame.component.html',
  styleUrls: ['./dropdown-frame.component.scss'],
  standalone: false
})
export class DropdownFrameComponent implements OnInit {
  resetIndicator: boolean;
  HIPContractDto: HIPContractDto;
  HIPInsuredPersonFromHIPDto: HIPInsuredPersonFromHIPDto;
  connectionKey: any;
  interruptionId: any;
  imagePath: any;

  constructor(public FlagService: FlagService,
              public ToastService: ToastService,
              public DataService: DataService,
              public AgeGroupService: AgeGroupService,
              public ValidationService: ValidationService,
              private HomeComponent: HomeComponent,
              private translate: TranslateService,
              private router: Router,
              private api: APIClient) { }

  ngOnInit(): void {
    this.ValidationService.updateRegex();

    let progressData = JSON.parse(sessionStorage.getItem('progressData'));
    let connectionKey = sessionStorage.getItem('connectionKey');
    let HIPInsuredPersonFromHIPDto = JSON.parse(sessionStorage.getItem('HIPInsuredPersonFromHIPDto'));
    let HIPContract = JSON.parse(sessionStorage.getItem('HIPContract'));
    let choosenAgeGroup = JSON.parse(sessionStorage.getItem('ageGroup'));
    let offerChoices = JSON.parse(sessionStorage.getItem('offerChoices'));
    this.DataService.connectionLinkType = sessionStorage.connectionLinkType;

    this.FlagService.bannerVisible = !choosenAgeGroup;

    if (progressData) {
      this.FlagService.flagServiceObject = progressData;
      this.DataService.HIPInsuredPersonFromHIPDto = HIPInsuredPersonFromHIPDto;
      this.DataService.HIPContractDto = HIPContract;
      this.AgeGroupService.choosenAgeGroup = choosenAgeGroup;
      this.AgeGroupService.offerChoices = offerChoices;

      // console.log(this.DataService.HIPContractDto)
      // console.log(this.AgeGroupService.choosenAgeGroup)
      // console.log(this.AgeGroupService.offerChoices)
      // console.log(this.DataService.HIPInsuredPersonFromHIPDto)
      // console.log(this.FlagService.flagServiceObject)
      // console.log(this.DataService.connectionLinkType)
    }

    // ezt a részt majd refaktorálni kellene! (queryParams?)
    let codeUrl = '';
    if (window.location.href.includes('code=')) {
      let code = '';
      const parts = window.location.href.split('code=');
      if (parts[1].includes('&')) {
        code = parts[1].split('&')[0];
      } else {
        code = parts[1];
      }
      codeUrl = '&code=' + code;
      sessionStorage.setItem('couponCode', code);
    }

    if(window.location.href.includes('localhost')) {
      //this.connectionKey = '51EA63DA-C046-4FEA-AD3B-631E63B936EB';
      //this.connectionKey = 'F289A311-3600-4924-969B-8AA52193081A';
      // this.connectionKey = 'B8A4EC3D-65DC-436E-877E-EF79FF756326';    //Teszt2 Mandula, 1992-02-02
      this.connectionKey = '0810C752-8631-4AFD-B454-7E8740E54A58';
      //this.connectionKey = 'F289A311-3600-4924-969B-8AA52193081A';
      //this.interruptionId = '0dbf4546-c989-446a-a060-89d6e9d70907'; // depricated coupon
      this.interruptionId = '976ACC95-D6A1-4CDD-A7AA-56B95CB5A115'; // active coupon
      sessionStorage.setItem('connectionKey', this.connectionKey);
      //SET custom value for testing purpose:
      this.getPassiveContract({navForwarding: false});
    } else {
      if(connectionKey !== undefined && connectionKey !== null && connectionKey !== 'undefined') {
        this.connectionKey = connectionKey;

        if(window.location.href.includes('&InterruptionId')) {
          this.connectionKey = this.connectionKey.split('&')[0];
          this.connectionKey = this.connectionKey.replace(codeUrl, '');
          sessionStorage.setItem('connectionKey', this.connectionKey);
          this.interruptionId = window.location.href.split('&InterruptionId=')[1];
          this.interruptionId = this.interruptionId.replace(codeUrl, '');

          this.getPassiveContract({navForwarding: true});
        } else {
          this.checkUrlKey(window.location.href);
          this.connectionKey = window.location.href.split('?key=')[1];
          this.connectionKey = this.connectionKey.replace(codeUrl, '');
          sessionStorage.setItem('connectionKey', this.connectionKey);

          this.getPassiveContract({navForwarding: false});
        }
      } else {
        if(window.location.href.includes('&InterruptionId')) {
          this.checkUrlKey(window.location.href);
          this.connectionKey = window.location.href.split('?key=')[1].split('&')[0];
          this.connectionKey = this.connectionKey.replace(codeUrl, '');
          sessionStorage.setItem('connectionKey', this.connectionKey);
          this.interruptionId = window.location.href.split('&InterruptionId=')[1];
          this.interruptionId = this.interruptionId.replace(codeUrl, '');

          this.getPassiveContract({navForwarding: true});
        } else {
          this.checkUrlKey(window.location.href);
          this.connectionKey = window.location.href.split('?key=')[1];
          this.connectionKey = this.connectionKey.replace(codeUrl, '');
          sessionStorage.setItem('connectionKey', this.connectionKey);

          this.getPassiveContract({navForwarding: false});
        }
      }
    }

    this.api.getContractAdministrationDataByConnectionKey({connectionKey: this.connectionKey}).subscribe(response => {
      const todayDate: Date = new Date();
      const today: string =
        todayDate.getFullYear() + '-'
        + ((todayDate.getMonth() + 1 < 10 ? '0' : '') + (todayDate.getMonth() + 1)) + '-'
        + (todayDate.getDate() < 10 ? '0' : '') + todayDate.getDate();

      if ((response.validFrom && today < response.validFrom.substring(0, 10)) ||
          (response.validTill && response.validTill.substring(0, 10) < today)) {
        this.router.navigate(['error']);
      } else {
          this.recieveLogo(response.logo);

          //set linkType for later use
          this.DataService.connectionLinkType = response.linkType;

          //SET for testing purpose:
          //this.DataService.connectionLinkType = "KOMPAKT_PARTNERI";

          this.DataService.setPageTitle();

          sessionStorage.setItem('connectionLinkType', this.DataService.connectionLinkType);
          sessionStorage.setItem('customStartDate', response.customStartDate === 1 ? 'true' : 'false');
      }
    }, error => {
//      this.ToastService.initializeMessage(error.message, 'error');
      this.router.navigate(['error']);
    });
  }

  private checkUrlKey(url: string): void {
    if (url.indexOf('?key=') < 0) {
      this.router.navigate(['error']);
    }
  }

  public bannerVisibleFalse(): void {
    this.FlagService.bannerVisible = false;
  }

  private recieveLogo(logo: string): void {
    if (logo) {
      this.imagePath = logo;
    } else {
      this.imagePath = false;
    }
  }

  getPassiveContract(navForwarding: object) {
    if(navForwarding[Object.keys(navForwarding)[1]]) {
      return
    }

    this.api.getPassiveContract({connectionKey: this.connectionKey}).subscribe(response => {
      this.HIPContractDto = response;
      this.HomeComponent._contractorName = response.contractorName;
      sessionStorage.setItem('HIPContract', JSON.stringify(this.HIPContractDto));

      //starting navigation forwarding
      if(navForwarding[Object.keys(navForwarding)[0]]) {
        this.getContractingProgress();
      }
    }, error => {
//      this.ToastService.initializeMessage(error.message, 'error');
      this.router.navigate(['error']);
    });
  }

  getContractingProgress() {
    //setting interruptionId for later use
    this.DataService.updateUserData("interruptionId");
    this.DataService.updateUserData({interruptionId: this.interruptionId, riskStartDate: this.HIPContractDto.subContractNextStartDate});
    sessionStorage.setItem('HIPInsuredPersonFromHIPDto', JSON.stringify(this.DataService.HIPInsuredPersonFromHIPDto));

    this.api.getInsuredPersonFromHipQuery({interruptionId: this.interruptionId}).subscribe(response => {
      //setting pre-choosen age group
      response.isAdult? this.AgeGroupService.choosenAgeGroup = [this.AgeGroupService.getAgeChoicesArray().find( ({id}) => id === '01' )] : this.AgeGroupService.choosenAgeGroup = [this.AgeGroupService.getAgeChoicesArray().find( ({id}) => id === '02' )];
      this.FlagService.flagServiceObject[1]['offerJunctureFlag'] = true;

      sessionStorage.setItem('ageGroup', JSON.stringify(this.AgeGroupService.choosenAgeGroup));
      sessionStorage.setItem('birthDay', response.insuredPerson.birthDate);
      this.bannerVisibleFalse();

      //setting insuredPerson person for later use
      this.DataService.updateUserData("insuredPerson");
      this.DataService.updateUserData(response.insuredPerson);
      sessionStorage.setItem('HIPInsuredPersonFromHIPDto', JSON.stringify(this.DataService.HIPInsuredPersonFromHIPDto));

      //setting pre-choosen offer in session storage
      let HIPContractDto = JSON.parse(sessionStorage.getItem('HIPContract'));
      for(let i in this.HIPContractDto.contractGroups) {
        if(HIPContractDto.contractGroups[i].contractGroupId == response.contractGroupId) {
          let preChoosenOffer = HIPContractDto.contractGroups[i];
          sessionStorage.setItem('preChoosenOffer', JSON.stringify(preChoosenOffer));
          break
        }

        //if pre-choosen offer is not found in the collection
        if(parseInt(i) + 1 === HIPContractDto.contractGroups.length) {
          sessionStorage.clear();
          this.FlagService.flagServiceObject[1]['offerJunctureFlag'] = false;
          return
        }
      }

      //skip to userDataJuncture
      this.FlagService.flagServiceObject[2]['familyJunctureFlag'] = true;
      this.FlagService.flagServiceObject[3]['userdataJunctureFlag'] = true;
    }, error => {
      if(error.error.validationErrors[0].errorCode !== "Validation_HIP_GetInsuredPerson_NotFound") {
        this.ToastService.initializeMessage(error.error.message, 'error');
      }
    });
  }

  junctureClick(flag: string, id: number) {
    this.FlagService.flagServiceObject[id][flag] = !this.FlagService.flagServiceObject[id][flag];
    this.resetIndicator = false;

    for (let i in this.FlagService.flagServiceObject) {
      let key = Object.keys(this.FlagService.flagServiceObject[i]).join();
      if(this.resetIndicator) {this.FlagService.flagServiceObject[i][key] = false;}
      if(key === flag) {this.resetIndicator = true;}
    }

    sessionStorage.setItem('progressData', JSON.stringify(this.FlagService.flagServiceObject));
  }

  userDataServe(event: any) {
    this.DataService.updateUserData(event);
  }
  returnInsurantData() {
    return this.DataService.HIPInsuredPersonFromHIPDto;
  }
}
